/**
 * LayoutHeaderContext — Tells child <PageHeader> instances whether
 * the AppLayout has already rendered the universal header.
 *
 * When `true`, per-page <PageHeader> calls skip title/breadcrumbs
 * and only render their `actions` slot.
 *
 * @since 2.1.0
 */
import { createContext } from 'react';

export const LayoutHeaderContext = createContext<boolean>(false);
